import types from '../types';
import { duckConstants } from '../../../constants';
import { extractState } from '../../../utilities/combineUseReducer';
import { get } from '../../../utilities/tips';

const reducer = (state, action) => {
  switch (action.type) {
    case types.REQUESTING: {
      return { ...state, requesting: action.requesting };
    }

    case types.CLEAR_SUCCESS_ERROR_FLAGS:
    case types.RESET_DATA: {
      return {
        liveToken: state ? state.liveToken : null,
        programming_languages: state ? state.programming_languages : null
      };
    }

    case types.GET_PROGRAMMING_LANGUAGE: {
      return state;
    }

    case types.GET_PROGRAMMING_LANGUAGE_SUCCESS: {
      return { ...state, programming_languages: action.result };
    }

    case types.GET_PROGRAMMING_LANGUAGE_ERROR: {
      return { ...state, programming_languages: null };
    }

    case types.GET_CHALLENGE_WITH_PROBLEM: {
      return state;
    }

    case types.GET_CHALLENGE_WITH_PROBLEM_SUCCESS: {
      return { ...state, challengeInfo: action.result };
    }

    case types.GET_CHALLENGE_WITH_PROBLEM_ERROR: {
      return { ...state, challengeInfo: null };
    }

    case types.CLEAR_LIVE_TOKEN: {
      return { ...state, liveToken: null };
    }

    case types.SET_LIVE_TOKEN: {
      return { ...state, liveToken: action.liveToken, clientData: action.clientData };
    }

    case types.ENDED_INTERVIEW: {
      return { ...state, endedInterview: action.lc_id, resetKey: null };
    }

    case types.INTERVIEWER_JOIN_ROOM: {
      const resetKey = state.resetKey || 0; /* TO RESTART THE RECORD DOM, OR ELSE THE FULL SNAPSHOT WILL NOT BE DELIVERED */
      return {
        ...state,
        resetKey: resetKey + 1,
        id: action.data.id,
        roomId: action.data.roomId
      };
    }

    case types.MESSAGE: {
      const messageRoom = `MESSAGE_${action.data.toRoomId}`;
      const currentMessages = state[messageRoom] || [];
      currentMessages.push(action.data);
      state[messageRoom] = currentMessages;
      return { ...state, latestMessage: action.data };
    }

    case types.CLEAR_LATEST_MESSAGE: {
      delete state.latestMessage;
      return state;
    }

    case types.ALREADY_JOIN: {
      return { ...state, alreadyJoin: true, resetKey: null };
    }

    case types.JOIN_SUCCESS: {
      return { ...state, joinSuccess: true };
    }

    case types.LOCAL_AUDIO_SWITCH: {
      if (state.localAudioOff === 'YES')state.localAudioOff = 'NO';
      else state.localAudioOff = 'YES';

      return { ...state };
    }

    case types.LOCAL_VIDEO_SWITCH: {
      if (state.localVideoOff === 'YES')state.localVideoOff = 'NO';
      else state.localVideoOff = 'YES';

      return { ...state };
    }

    case types.GET_LATEST_SUBMIT_INFO: {
      return { ...state, loadingLatestSubmit: true };
    }

    case types.GET_LATEST_SUBMIT_INFO_SUCCESS: {
      const submittedCount = action.result ? action.result.length : 0;
      const totalProblems = get(['result', 0, 'total_problem'], action) || 0;
      const allSubmitted = (submittedCount > 0 && totalProblems > 0 && submittedCount >= totalProblems);
      const submitId = get(['result', 0, 'submit_id'], action) || 'none';
      return { ...state, loadingLatestSubmit: false, submitId, allSubmitted };
    }

    case types.GET_LATEST_SUBMIT_INFO_ERROR: {
      return {
        ...state,
        loadingLatestSubmit: false
      };
    }

    case types.MASTER_BROADCAST_AUDIO_DISABLED: {
      state.masterAudioDisabled = true;
      return { ...state };
    }

    case types.MASTER_BROADCAST_AUDIO_ENABLED: {
      delete state.masterAudioDisabled;
      return { ...state };
    }

    case types.AV_NOT_ALLOWED: {
      return { ...state, av_not_allowed: 'User not allowed Audio/Video' };
    }

    case types.AV_ALLOWED: {
      delete state.av_not_allowed;
      return { ...state };
    }

    case types.AV_NOT_AVAILABLE: {
      return { ...state, av_not_available: action.message };
    }

    case types.SOCKET_ERROR: {
      return { ...state, socketError: action.data };
    }

    case types.REMOTE_TRACK_STATE: {
      return { ...state, remote_track_state: action.state };
    }

    case types.REHYDRATE: {
      /* INITIAL STATE */
      const initialState = (state && state[stateKey]) ? { ...state[stateKey] } : extractState(duckConstants.LCI_LIVE_CODE, stateKey);
      return { ...state, ...initialState };
    }

    default:
      return state;
  }
};

const stateKey = 'lciCode';

export default { reducer, stateKey };
